import { useState } from 'react';
import * as v from 'valibot';

import { createFileRoute, redirect } from '@tanstack/react-router';

import { ErrorBoundary } from 'react-error-boundary';

import { claimDataQueries } from '@repo/api/claim/data';
import { TransactionError, TransactionResult } from '@repo/api/errors.types';
import { DataError, DataErrorKeys } from '@repo/api/shared/data.types';
import { Error } from '@repo/features/data';

import { Route as DocumentsRoute } from '../documents';
import { DataPage } from './DataPage';

export const Route = createFileRoute(
	'/_authenticated/claim/$claimId/_claim/data/',
)({
	beforeLoad: ({ params, context }) => {
		if (!context.user?.permissions.includes('shared.data.view')) {
			throw redirect({
				to: DocumentsRoute.to,
				params,
			});
		}
	},
	loader: ({ context, params }) => {
		void context.queryClient.ensureQueryData(
			claimDataQueries.id(params.claimId),
		);
	},
	component: function ClaimDataPage() {
		const [pageError, setPageError] =
			useState<TransactionResult<DataError> | null>(null);

		return (
			<ErrorBoundary
				onError={(error) => {
					if (
						error instanceof TransactionError &&
						v.is(TransactionResult(DataErrorKeys), error.result)
					) {
						setPageError(error.result);
					}
				}}
				onReset={() => {
					setPageError(null);
				}}
				fallback={<Error error={pageError} />}
			>
				<DataPage />
			</ErrorBoundary>
		);
	},
	head: (ctx) => ctx.match.context.setTitle('Claim', 'Data'),
});
